import { Action, createReducer, on } from "@ngrx/store";
import { SOPO_LOADING_INIT_STATE, ISopoLoadingState, LOADING_INIT_STATE } from "./loading.state";
import * as loadingActions from "./loading.actions";

const _loadingReducer = createReducer(

    SOPO_LOADING_INIT_STATE,

    on(
        loadingActions.presentLoading,
        (state, action) => ({
            ...state,
            presented: { 
                ...state.presented,
                [action.loadingKey]: true,
            }
        })
    ),

    on(
        loadingActions.dismissLoading,
        (state, action) => ({
            ...state,
            presented: { 
                ...state.presented,
                [action.loadingKey]: false,
            }
        })
    ),

    on(
        loadingActions.dismissAllLoading,
        (state) => ({
            ...state,
            presented : {
                ...LOADING_INIT_STATE
            }
        })
    ),

    on(
        loadingActions.pauseLoading,
        (state) => ({
            ...state,
            paused: true,
        })
    ),

    on(
        loadingActions.resumeLoading,
        (state) => ({
            ...state,
            paused: false,
        })
    ),
);

export function loadingReducer(state: ISopoLoadingState, action: Action) {
    return _loadingReducer(state, action);
}